import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../components/primitives/Panel';
import { withBrandWord } from '../../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the period sections; each part uses its own slice of it */
import styles from '../StreamingPeriod.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SectionNoneCardProps {
  icon: IconDefinition;
  title: string;
  text?: string;
  testId: string;
  /** The buttons under the text. */
  children?: React.ReactNode;
}

/**
 * "Not available for this source or period" (design streaming-sections a3, c2, d2). It is not an
 * error and not the empty state of e2.
 */
const SectionNoneCardComponent: React.FC<SectionNoneCardProps> = ({ icon, title, text, testId, children }) => (
  <Panel as="section" className={styles.none} data-testid={testId}>
    <span className={styles.noneIcon} aria-hidden>
      <FontAwesomeIcon icon={icon} />
    </span>
    <h3>{withBrandWord(title)}</h3>
    {text !== undefined ? <p>{withBrandWord(text)}</p> : null}
    {children !== undefined ? <div className={styles.noneActions}>{children}</div> : null}
  </Panel>
);

export const SectionNoneCard = TypedMemo(SectionNoneCardComponent);
